// Two-line labels for the category buttons in the header (small line on top, main word below).
export default {
  rail: {
    categories: {
      all: { top: "Todos os", bottom: "Passeios" },
      escunas: { top: "Passeios de", bottom: "Escuna" },
      privadas: { top: "Lanchas e Escunas", bottom: "Privadas" },
      compartilhadas: { top: "Lanchas", bottom: "Compartilhadas" },
      jeep: { top: "Passeios de", bottom: "Jeep" },
      bolivia: { top: "Expedição", bottom: "Bolívia" },
    },
  },
};
